import { IconSend } from '@tabler/icons-react';
import { Button } from '@zorro/design-system/v2/Button';
import { TextInput } from '@zorro/design-system/v2/TextInput';
import { useMonolithMutation } from '@zorro/web/ui-utils';
import { Controller, UseFormReturn } from 'react-hook-form';

import { SendInviteFormFields } from './SendInviteUtils';

type Props = {
  sendInviteForm: UseFormReturn<SendInviteFormFields>;
  employerId: string;
  onSubmit?: () => void;
};

export const InviteByEmailForm = ({
  sendInviteForm,
  employerId,
  onSubmit,
}: Props) => {
  'use no memo';
  const { mutate: mutateInviteEmployer } = useMonolithMutation({
    method: 'employersControllerInviteEmployerAdmin',
    successMessage: 'Employer invitation email sent',
  });

  const { control, formState, watch } = sendInviteForm;
  const email = watch('email');

  const handleSubmit = async () => {
    try {
      await mutateInviteEmployer([employerId, email, true]);
      onSubmit?.();
    } catch {
      /* empty */
    }
  };

  return (
    <Controller
      control={control}
      name="email"
      render={({ field: { ...rest } }) => (
        <TextInput
          {...rest}
          label="Invitation email"
          placeholder="Add invitation email"
          rightSectionWidth="155px"
          size="md"
          rightSectionProps={{ style: { paddingRight: '2px' } }}
          rightSection={
            <Button
              size="sm"
              variant="primary"
              disabled={!formState.isValid}
              onClick={handleSubmit}
              leftSection={<IconSend size={16} />}
            >
              Send invitation
            </Button>
          }
        />
      )}
    />
  );
};
